import { format, isSameDay, lastDayOfMonth, startOfMonth, startOfWeek, subMonths } from "date-fns";

export type DateStates = Date | null | undefined;

export const V3_DATE_PRESETS = [{
    label: "Today",
    start: new Date(),
    end: new Date()
}, {
    label: "This week",
    start: startOfWeek(new Date()),
    end: new Date()
}, {
    label: "This month",
    start: startOfMonth(new Date()),
    end: new Date()
}, {
    label: "Last month",
    start: startOfMonth(subMonths(new Date(), 1)),
    end: lastDayOfMonth(subMonths(new Date(), 1))
}, {
    label: "Last 6 months",
    start: startOfMonth(subMonths(new Date(), 6)),
    end: new Date()
}, {
    label: "Last year",
    start: startOfMonth(subMonths(new Date(), 12)),
    end: new Date()
}, {
    label: "All time",
    start: null,
    end: null
}, {
    label: "No Date",
    start: undefined,
    end: undefined
}];

export const getV3DateText = (
    startDate: Date | null | undefined,
    endDate: Date | null | undefined,
    useRange: boolean,
) => {
    if (!useRange && startDate) return format(startDate, 'MMM d, yy');

    if (startDate === null && endDate === null) return "All Time";
    if (startDate === undefined && endDate === undefined) return "No date";

    const startDateFormatted = startDate ? format(startDate, 'dd. MMM yy') : "";
    const endDateFormatted = endDate ? format(endDate, 'dd. MMM yy') : "";

    return `${startDateFormatted} - ${endDateFormatted}`;
}


export const isDateActive = (startDate: DateStates, endDate: DateStates, start: DateStates, end: DateStates) => {
    if (startDate && endDate && start && end) {
        return isSameDay(startDate, start) && isSameDay(endDate, end);
    }

    return startDate === start && endDate === end;
}

export const V3GetFormattedDate = (fromDate?: string | null, toDate?: string | null) => {
    let formattedFromDate: DateStates, formattedToDate: DateStates;

    // format the dates
    if (toDate) {
        //@ts-ignore
        const from = fromDate.split("-").map(val => parseInt(val, 10));
        //@ts-ignore
        const to = toDate.split("-").map(val => parseInt(val, 10));

        formattedFromDate = new Date(from[0], from[1] - 1, from[2]);
        formattedToDate = new Date(to[0], to[1] - 1, to[2]);

    } else {
        //@ts-ignore
        formattedFromDate = fromDate;
        //@ts-ignore
        formattedToDate = toDate;
    }

    return { formattedFromDate, formattedToDate };
}
